import { OutboundMessage, OutboundMessageType } from '@playcastdotio/Messaging';
import { getStateStore } from '../../../stores';
import { DateTime } from 'luxon';

export const handleOutboundMessage = (message: OutboundMessage) => {
  console.log('Outbound message:', message);
  const state = getStateStore('ipc');

  switch (message.type) {
    case OutboundMessageType.OUTBOUND_LIMITS_REPLY: {
      // Handle quota limits reply
      console.log('Received quota limits:', message.email);
      state.invitationSendState.updateState({
        ...state.invitationSendState.currentState,
        reachedSmsInviteLimit: message.sms.count >= message.sms.limit,
        smsLimitExpiry: DateTime.fromISO(message.sms.limitExpiry).valueOf(),
        smsLimit: message.sms.limit,
        smsCount: message.sms.count,
        reachedEmailInviteLimit: message.email.count >= message.email.limit,
        emailLimitExpiry: DateTime.fromISO(message.email.limitExpiry).valueOf(),
        emailLimit: message.email.limit,
        emailCount: message.email.count,
      });
      break;
    }
    case OutboundMessageType.OUTBOUND_SMS_REPLY: {
      // Handle SMS reply
      console.log('Received SMS reply:', message.success);
      if (message.success) {
        state.invitationSendState.updateState({
          ...state.invitationSendState.currentState,
          smsCount: (state.invitationSendState.currentState.smsCount || 0) + 1,
        });
      }
      break;
    }
    case OutboundMessageType.OUTBOUND_EMAIL_REPLY: {
      // Handle email reply
      console.log('Received email reply:', message.success);
      if (message.success) {
        state.invitationSendState.updateState({
          ...state.invitationSendState.currentState,
          emailCount: (state.invitationSendState.currentState.emailCount || 0) + 1,
        });
      }
      break;
    }
    case OutboundMessageType.OUTBOUND_ERROR: {
      // Handle error
      console.error('Outbound error:', message.error);
      break;
    }
    default: {
      console.warn('Unknown outbound message type:', message.type);
    }
  }
};
